import { memo, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import ReviewsRating from "../../../components/reviewsRating/ReviewsRating";
import { theme } from "../../../theme";
import Reviews from "../../../ftm/reviews/Reviews";

const StatusBadge = memo(({ label }) => (
    <div className="d-flex align-items-center me-2">
        <i className={`material-icons text-sm me-1 text-${theme.main}`}>
            check_circle
        </i>
        <span className="text-sm text-dark text-bold">{label}</span>
    </div>
));

const FtmDetails = ({ ftm }) => {
    const {
        ftm_id,
        ftm_forename,
        ftm_surname,
        ftm_profile_image_path,
        ftm_total_ratings,
        ftm_total_reviews,
        ftm_is_verify,
        ftm_background_is_check,
    } = ftm;

    const showStatus = useMemo(
        () => ftm_is_verify === 1 || ftm_background_is_check === 1,
        [ftm_is_verify, ftm_background_is_check]
    );

    const [openReviews, setOpenReviews] = useState(false);

    const handleOpenReviews = () => setOpenReviews(true);
    const handleCloseReviews = () => setOpenReviews(false);

    return (
        <div className="card h-100">
            <div className="card-header pb-0 p-3">
                <h6 className="text-start">Tradespersons Details</h6>
            </div>
            <div className="card-body p-3 pt-1 pb-3">
                <div className="row">
                    {/* LEFT */}
                    <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center">
                        <img
                            src={ftm_profile_image_path || "/assets/img/lock_user.png"}
                            alt={`${ftm_forename} ${ftm_surname}`}
                            width={90}
                            height={90}
                            className="border-radius-lg me-3"
                        />

                        <div>
                            <h6 className="text-lg mb-0 mt-2">
                                {ftm_forename} {ftm_surname}
                            </h6>

                            <span
                                className="text-sm text-dark text-bold d-inline-flex align-items-center gap-1"
                            >
                                <ReviewsRating rating={ftm_total_ratings} />
                                {ftm_total_ratings} ({ftm_total_reviews} reviews)
                            </span>

                            {showStatus && (
                                <div className="d-flex pt-2" style={{ marginTop: -10 }}>
                                    {ftm_is_verify === 1 && (
                                        <StatusBadge label="Verified" />
                                    )}
                                    {ftm_background_is_check === 1 && (
                                        <StatusBadge label="Background checked" />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="col-lg-6 col-md-6 col-12 my-auto text-end">
                        <button type="button" className={`btn bg-gradient-${theme.main} btn-sm mb-0 me-3`} onClick={handleOpenReviews}>
                            <i className="material-icons text-lg">reviews</i>{" "}
                            Reviews
                        </button>

                        <Link to={`/ftm/view/${ftm_id}`} className="btn bg-gradient-dark btn-sm mb-0">
                            <i className="material-icons text-lg">list_alt</i>{" "}
                            Details
                        </Link>
                    </div>
                </div>
            </div>

            <Reviews
                ftm_id = {ftm_id}
                open = {openReviews}
                close = {handleCloseReviews}
            />
        </div>
    );
};

export default memo(FtmDetails);